import React from 'react'
import { Outlet } from 'react-router-dom'

const AboutPage: React.FC = () => {
    return (
        <div className="flex flex-col w-full h-full items-center justify-start bg-[#f0f3f5]">
            <div className="flex w-full h-24"></div>

            <div className="flex flex-col w-full gap-24 items-center justify-center">
                <div className="flex flex-col w-full h-fit items-center justify-center">
                    <Outlet />
                </div>
            </div>
        </div>
    )
}

export default AboutPage
